module.exports = __webpack_public_path__ + "img/JSD600.0f330a56.png";